import { cn } from '@bem-react/classname';

export const cnRadioButton = cn('RadioButton');
